import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'bosch-ui-activity-indicator-backdrop',
  imports: [CommonModule],
  templateUrl: './bosch-ui-activity-indicator-backdrop.component.html',
  styleUrls: ['./bosch-ui-activity-indicator-backdrop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiActivityIndicatorBackdropComponent {
  @Input() visible = false;
}
